import { Chip } from '@mui/material';
import type { ChipProps } from '@mui/material';

const COLORS: Record<string, ChipProps['color']> = {
  Active: 'success',
  LIVE: 'success',
  Free: 'success',
  Available: 'success',
  Completed: 'success',
  success: 'success',
  Complete: 'success',
  Paid: 'success',
  Used: 'info',
  Dispatched: 'info',
  Suspended: 'warning',
  Incomplete: 'warning',
  // Ticket statuses.
  Open: 'info',
  'In Progress': 'info',
  'In Working': 'info',
  Pending: 'warning',
  'Call Back': 'warning',
  Escalation: 'error',
  Closed: 'default',
  Processing: 'info',
  Uploaded: 'info',
  DEMO: 'warning',
  Bad: 'error',
  Fraud: 'error',
  'Lost/Stolen': 'error',
  Lost: 'error',
  Failed: 'error',
  failure: 'error',
  Locked: 'error',
  Inactive: 'default',
  Removed: 'default',
};

/** Coloured label for any status value used across the product. */
export function StatusChip({ status, label }: { status: string; label?: string }) {
  return (
    <Chip
      size="small"
      label={label ?? status}
      color={COLORS[status] ?? 'default'}
      variant={COLORS[status] === 'default' || !COLORS[status] ? 'outlined' : 'filled'}
      sx={{ height: 20, fontSize: 12 }}
    />
  );
}
